"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenFaucet = void 0;
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const bn_js_1 = __importDefault(require("bn.js"));
const associatedToken_1 = require("./associatedToken");
class TokenFaucet {
    /**
     * TODO:
     * @private
     * @static
     * @param {TransactionInstruction[]} instructions
     * @param {PublicKey} tokenMint
     * @param {PublicKey} tokenFaucet
     * @param {PublicKey} tokenAccount
     * @memberof TokenFaucet
     */
    static async withAirdrop(instructions, tokenMint, tokenFaucet, tokenAccount) {
        const pubkeyNonce = await web3_js_1.PublicKey.findProgramAddress([Buffer.from("faucet", "utf8")], this.FAUCET_PROGRAM_ID);
        const keys = [
            { pubkey: pubkeyNonce[0], isSigner: false, isWritable: false },
            {
                pubkey: tokenMint,
                isSigner: false,
                isWritable: true
            },
            { pubkey: tokenAccount, isSigner: false, isWritable: true },
            { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
            { pubkey: tokenFaucet, isSigner: false, isWritable: false }
        ];
        const faucetIx = new web3_js_1.TransactionInstruction({
            programId: this.FAUCET_PROGRAM_ID,
            data: Buffer.from([1, ...new bn_js_1.default(10000000000000).toArray("le", 8)]),
            keys
        });
        instructions.push(faucetIx);
    }
    /**
     * TODO:
     * @static
     * @param {Provider} provider
     * @param {PublicKey} faucet
     * @param {PublicKey} user
     * @param {PublicKey} mint
     * @returns {Promise<string>}
     * @memberof TokenFaucet
     */
    static async airdropToken(provider, faucet, user, mint) {
        const instructions = [];
        // Check for user token account
        // If it doesn't exist add instructions to create it
        const address = await associatedToken_1.AssociatedToken.withCreate(instructions, provider, user, mint);
        // Create airdrop instructions
        await this.withAirdrop(instructions, mint, faucet, address);
        // Execute airdrop
        return provider.send(new web3_js_1.Transaction().add(...instructions));
    }
}
exports.TokenFaucet = TokenFaucet;
/**
 * Airdrop faucet program public key.
 * @static
 * @memberof TokenFaucet
 */
TokenFaucet.FAUCET_PROGRAM_ID = new web3_js_1.PublicKey("4bXpkKSV8swHSnwqtzuboGPaPDeEgAn4Vt8GfarV5rZt");
//# sourceMappingURL=tokenFaucet.js.map